import { Column } from "@covertree/ui/table/types";

import {
  GetResidentsFilterStatus,
  GetResidentsSortBy,
  InsuranceAdoptionStatus,
  PolicyType,
} from "@graphql/api";

export enum RemovableResidentColumn {
  PolicyType = "Policy Type",
  CommunityPortfolio = "Community Portfolio",
  InsuranceAdoptionStatus = "Insurance Adoption Status",
}

export const RESIDENTS_TABLE_COLUMNS: Column[] = [
  { headerName: "Resident ID", sortBy: GetResidentsSortBy.ResidentId },
  { headerName: "Name", sortBy: GetResidentsSortBy.Name },
  { headerName: "Site Address", sortBy: GetResidentsSortBy.SiteAddress },
  { headerName: "Lot/Unit #", sortBy: GetResidentsSortBy.LotUnit },
  {
    headerName: RemovableResidentColumn.InsuranceAdoptionStatus,
    sortBy: GetResidentsSortBy.InsuranceAdoptionStatus,
  },
  {
    headerName: RemovableResidentColumn.PolicyType,
  },
  { headerName: "Community Name", sortBy: GetResidentsSortBy.CommunityName },
  {
    headerName: RemovableResidentColumn.CommunityPortfolio,
    sortBy: GetResidentsSortBy.PortfolioName,
  },
  { headerName: "Created Date", sortBy: GetResidentsSortBy.CreatedDate },
  {
    headerName: "Updated Date",
    sortBy: GetResidentsSortBy.UpdatedDate,
  },
];

export const RESIDENTS_SEARCH_TABLE_COLUMNS = [
  { headerName: "Resident ID" },
  { headerName: "Name" },
  { headerName: "Site Address" },
  { headerName: "Lot/Unit #" },
  { headerName: RemovableResidentColumn.InsuranceAdoptionStatus },
];

const removeColumnsFilterFromRequirementSatisfiedStatus = [
  RemovableResidentColumn.InsuranceAdoptionStatus,
];

const removeColumnsFilter = [
  RemovableResidentColumn.PolicyType,
  RemovableResidentColumn.InsuranceAdoptionStatus,
];

const filterToRemoveColumnsMap: Record<
  GetResidentsFilterStatus,
  RemovableResidentColumn[]
> = {
  [GetResidentsFilterStatus.All]: [],
  [GetResidentsFilterStatus.RequirementSatisfied]:
    removeColumnsFilterFromRequirementSatisfiedStatus,
  [GetResidentsFilterStatus.PreReview]: removeColumnsFilter,
  [GetResidentsFilterStatus.UnderReview]: removeColumnsFilter,
  [GetResidentsFilterStatus.RequirementUnsatisfied]: removeColumnsFilter,
  [GetResidentsFilterStatus.Excluded]: removeColumnsFilter,
};

export const getColumnsToRemove = (
  filter: GetResidentsFilterStatus,
  isCommunityManagerOrExecutive = false
) => {
  return isCommunityManagerOrExecutive
    ? [
        ...filterToRemoveColumnsMap[filter],
        RemovableResidentColumn.CommunityPortfolio,
      ]
    : filterToRemoveColumnsMap[filter];
};

export const createColumnValueChecker = (columns: Column[]) => {
  const availableColumns = columns.map(({ headerName }) => headerName);

  return (
    columnName: RemovableResidentColumn,
    value: string | number | undefined | null
  ) => {
    return availableColumns.includes(columnName) ? [value ?? ""] : [];
  };
};

export const mapResidentInsuranceAdoptionStatus = (
  status: InsuranceAdoptionStatus | null | undefined
) => {
  switch (status) {
    case InsuranceAdoptionStatus.RequirementSatisfied:
      return "Requirement Satisfied";
    case InsuranceAdoptionStatus.PreReview:
      return "Pre Review";
    case InsuranceAdoptionStatus.UnderReview:
      return "Under Review";
    case InsuranceAdoptionStatus.RequirementUnsatisfied:
      return "BRL-Scheduled";
    case InsuranceAdoptionStatus.Excluded:
      return "Excluded";
    case null:
    case undefined:
      return "N/A";
    default:
      return status;
  }
};
export const mapPolicyType = (
  policyType: PolicyType | null | undefined,
  insuranceAdoptionStatus?: InsuranceAdoptionStatus
) => {
  if (
    insuranceAdoptionStatus &&
    insuranceAdoptionStatus !== InsuranceAdoptionStatus.RequirementSatisfied &&
    insuranceAdoptionStatus !== InsuranceAdoptionStatus.RequirementUnsatisfied
  )
    return "—";
  switch (policyType) {
    case PolicyType.TLL:
      return "MH-TLL";
    case PolicyType.HomeOwners:
      return "MH-Homeowners";
    case PolicyType.External:
      return "MH-External";
    case null:
    case undefined:
      return "—";
    default:
      return policyType;
  }
};
